import { createFileRoute } from "@tanstack/react-router";

import { SiteListPage } from "../features/sites/SiteListPage";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/",
)({
  component: SitesListRoute,
});

function SitesListRoute() {
  const { accountSlug, tenantSlug } = Route.useParams();
  return <SiteListPage accountSlug={accountSlug} tenantSlug={tenantSlug} />;
}
